import { Box, styled } from '@mui/material';

export const Descriptions = styled(Box)({
  color        : '#231F20',
  fontFamily   : 'Montserrat',
  marginTop    : '34px',
  marginBottom : '37px',
});
